export default __webpack_public_path__ + "static/media/(87).6e97b67e.jpg";